<template>
  <div class="browser-container">
    <div class="wrapper">
      <h1 class="title">Choose deposit method</h1>
      <ul class="item-list">
        <router-link to="/step2">
          <li class="item active">
          <div class="icon-wrapper">
            <svgicon name="bitcoin" width="49" height="49" :original="true"></svgicon>
          </div>
          <span class="item-caption active">Сryptocurrency</span>
        </li>
        </router-link>
        <!--<li class="item">-->
          <!--<div class="icon-wrapper">-->
            <!--<img class="icon" src="../../assets/img/skrull.png" alt="Skrull"/>-->
          <!--</div>-->
        <!--</li>-->
        <!--<li class="item">-->
          <!--<div class="icon-wrapper">-->
            <!--<img class="icon" src="../../assets/img/nuteller.jpg" alt="Nuteller"/>-->
          <!--</div>-->
        <!--</li>-->
        <li class="item">
          <div class="icon-wrapper">
            <img class="icon" src="../../assets/img/card.png" alt="Pre-paid card"/>
          </div>
        </li>
        <li class="item">
          <div class="icon-wrapper">
            <img class="icon" src="../../assets/img/wallet.png" alt="E-wallet"/>
          </div>
        </li>
        <li class="item">
          <div class="icon-wrapper">
            <img class="icon" src="../../assets/img/museum.png" alt="Deposit method"/>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import '../../assets/compiled-icons/index';

export default {
  name: 'Step1'
};
</script>

<style scoped>
/* Keyframes for the fade-in */
@keyframes fadeIn { from { opacity:0; } to { opacity:1; } }

/* Keyframes for moving from bottom to top */
@keyframes go-bottom-top {
  from {
    top: 240px;
  }
  to {
    top: 0px;
  }
}

.wrapper {
  animation: go-bottom-top 2s;
}

/* Animation - title appearance in  0.4s*/
.title {
  opacity: 0;
  animation: fadeIn ease-in 1;
  animation-fill-mode:forwards;
  animation-duration: 0.5s;
  animation-delay: 0.2s;
}

/* Animation - content appearance in 2s */
.item-list {
  opacity: 0;
  animation: fadeIn ease-in 1;
  animation-fill-mode: forwards;
  animation-duration: 0.5s;
  animation-delay: 1s;
}

.tooltip {
  animation-delay: 2s;
}
</style>



// WEBPACK FOOTER //
// src/components/steps/Step1.vue